import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#101010",
  d: "M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M8 1.143A6.863 6.863 0 0 0 1.143 8 6.863 6.863 0 0 0 8 14.857 6.86 6.86 0 0 0 14.857 8 6.863 6.863 0 0 0 8 1.143"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#101010",
  d: "M10.429 11a.6.6 0 0 1-.297-.075L7.274 9.309a.55.55 0 0 1-.202-.197A.5.5 0 0 1 7 8.846V4.538C7 4.237 7.251 4 7.571 4s.572.237.572.538v4.007l2.583 1.453a.55.55 0 0 1 .234.264c.046.11.052.23.019.343a.54.54 0 0 1-.205.284c-.1.072-.22.11-.345.111"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }